import React, { useEffect, Fragment, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { DfpComponent } from "../../../ads/dfp-component";
import SearchEntity from "../search-entity/search";
import { ProfileImage } from "../profile-image";
import TrendingStories from "../trending-stories";

import "./companies.m.css";

export function EntityPageCompanies({ data = {}, config = {} }) {
  const sketchesHost = config["sketches-host"];

  let placeData = get(data, ["data", "entities"], []);
  placeData = placeData.sort((a, b) => Number(a.sequence || 200) - Number(b.sequence || 200));
  const [showLoadmore, setShowLoadmore] = useState(false);
  const limit = 16;
  const [offset, setOffset] = useState(limit);
  const [items, setItems] = useState(placeData?.length > limit ? placeData.slice(0, limit) : placeData);
  const entityName = "company";

  const getLoadMorePlaces = async () => {
    const newItems = placeData.slice(offset, limit + offset);
    setItems([...items, ...newItems]);
    setOffset((prevOffset) => prevOffset + limit);
  };

  const handleLoadMore = async () => {
    await getLoadMorePlaces();
  };

  const midAd1 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "mid_page_1"], {}));
  const midAd2 = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "mid_page_2"], {}));
  const footerAd = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "footer_1"], {}));

  useEffect(() => {
    items?.length >= offset ? setShowLoadmore(true) : setShowLoadmore(false);
  }, [offset]);

  return (
    <div styleName="entity-companies-container">
      <div styleName="top-banner">
        <img src="https://images.assettype.com/gulfnews/2026-10-01/c3cxhszm/Company-desktop.png" />
      </div>
      <div styleName="top-banner-mobile">
        <img src="https://images.assettype.com/gulfnews/2026-10-01/sawosdm5/Company-mobile.png" />
      </div>
      <SearchEntity entityName={entityName} onResults={setItems} />
      {items?.length ? (
        <div styleName="entity-list">
          {items.map((item, index) => {
            const profileImg = get(item, ["logo"], []);
            return (
              <Fragment key={index}>
                <div styleName="entity-list-detail">
                  <Link href={`${sketchesHost}/companies/${item?.slug}`}>
                    <ProfileImage imageUrl={profileImg} defaultWidth="90" entityName={entityName} />
                  </Link>
                  <div styleName="info">
                    <Link href={`${sketchesHost}/companies/${item?.slug}`}>
                      <div styleName="name">{item?.name}</div>
                    </Link>
                    <div styleName="bio">{item?.tagline}</div>
                    <div styleName="details">
                      <Link href={`${sketchesHost}/companies/${item?.slug}`}>View Profile</Link>
                    </div>
                  </div>
                </div>
                {index === 21 && (
                  <div styleName="ad-slot-970x250-wrapper">
                    <DfpComponent adStyleName={"ad-slot-size-970x250"} id={midAd2?.id} />
                  </div>
                )}
              </Fragment>
            );
          })}
        </div>
      ) : (
        <div styleName="entity-list no-result">No result found.</div>
      )}
      {showLoadmore && <div styleName="load-more">{<button onClick={handleLoadMore}>LOAD MORE</button>}</div>}
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName={"ad-slot-size-970x250"} id={midAd1?.id} />
      </div>
      <TrendingStories />
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName="ad-slot-size-970x250" id={footerAd?.id} />
      </div>
    </div>
  );
}
